export enum TabKey {
  users = "users",
  location = "locations",
}
